import React, { Component } from "react";
import { Button ,Icon ,Modal, message } from "antd";
import API_URL from "../../../common/url";
import Filter from "./Filter";
import TableC from "../../basicElement/TableC";
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import UserSider from '../UserSider';

class UserDimission extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams:{},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        const {searchParams, pagination, sortParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserLeftRecord,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    search = (searchParams) => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({searchParams,pagination},
            () => {
                this.loadData();
            }
        );
    };

    // export = searchParams => {
    //     const { pagination, sortParams } = this.state;
    //     const { current, pageSize } = pagination;
    //     const options = {
    //         method: 'POST',
    //         url: API_URL.user.exportUserLeftRecord,
    //         data: {
    //             offset: current,
    //             limit: pageSize,
    //             ...searchParams,
    //             ...sortParams,
    //         },
    //         dataType: 'json',
    //         doneResult: res => {
    //             message.success(res.success)
    //         }
    //     };
    //     $.sendRequest(options);
    // };

    export = searchParams => {
        const { pagination, sortParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.user.exportUserLeftRecord);
        message.success('正在导出')
    }

    getColumns = () => {
        const columns = [
            {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 100,
            },{
                title: '姓名',
                dataIndex: 'userName',
                key: 'userName',
                width: 100,
            },{
                title: '职位',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 100,
            },{
                title: '主管工号',
                dataIndex: 'leaderCode',
                key: 'leaderCode',
                width: 100,
            },{
                title: '主管姓名',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 100,
            },{
                title: '计划离职日期',
                dataIndex: 'leftTime',
                key: 'lefTime',
                width: 100,
                render: text => text ? text.slice(0,10) : ''
            },{
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 160,
            },{
                title: '大项目经理姓名',
                dataIndex: 'pmName',
                key: 'pmName',
                width: 100,
            },{
                title: '大项目经理工号',
                dataIndex: 'pmCode',
                key: 'pmCode',
                width: 100,
            },{
                title: '是否完成交接',
                dataIndex: 'completeHandover',
                key: 'completeHandover',
                width: 100,
                render: text => text == 0 ? '否': text == 1?'是':''
            },
            
        ];
    return columns;
    };

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const {
            data,
            loading,
            pagination,
            sortParams,
        } = this.state;
        return (
            <div className="content">
                <UserSider selectKey="UserDimission" openKeys={['sub1']}/>
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                    />
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
            </div>
        );
    }
}

export default UserDimission;



// WEBPACK FOOTER //
// ./src/components/user/userDimission/index.js